// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit2, Loader2 } from 'lucide-react';
import ProfileManagementModal from '@/components/vendor/ProfileManagementModal';

interface VideoVendorProfile {
  id: string;
  user_id: string;
  business_name?: string;
  rating_average?: number;
  review_count?: number;
  description?: string;
  created_at: string;
  updated_at: string;
}

const VendorProfile: React.FC = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [vendorProfile, setVendorProfile] = useState<VideoVendorProfile | null>(null);
  const [showProfileModal, setShowProfileModal] = useState(false);

  useEffect(() => {
    fetchVendorProfile();
  }, [user?.id]);

  const fetchVendorProfile = async () => {
    if (!user?.id) return;

    try {
      const { data, error } = await supabase
        .from('video_vendor_profiles')
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) throw error;
      setVendorProfile(data);
    } catch (error) {
      console.error('Error fetching vendor profile:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="flex items-center gap-2">
            <Loader2 className="h-6 w-6 animate-spin" />
            <span>Loading profile...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Vendor Profile</h1>
        <p className="text-muted-foreground">Manage your video vendor profile information</p>
      </div>

      <div className="grid gap-6">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between">
            <CardTitle>Business Information</CardTitle>
            <Button
              onClick={() => setShowProfileModal(true)}
              className="flex items-center gap-2"
            >
              <Edit2 className="h-4 w-4" />
              Edit Profile
            </Button>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <label className="text-sm font-medium text-muted-foreground">Business Name</label>
              <p className="text-lg">{vendorProfile?.business_name || 'Not set'}</p>
            </div>
            
            <div>
              <label className="text-sm font-medium text-muted-foreground">Description</label>
              <p className="text-sm">{vendorProfile?.description || 'No description provided'}</p>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-muted-foreground">Average Rating</label>
                <p className="text-lg">{vendorProfile?.rating_average?.toFixed(1) || '0.0'} / 5.0</p>
              </div>
              
              <div>
                <label className="text-sm font-medium text-muted-foreground">Total Reviews</label>
                <p className="text-lg">{vendorProfile?.review_count || 0}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <ProfileManagementModal
        open={showProfileModal}
        onOpenChange={setShowProfileModal}
        vendorProfile={vendorProfile}
        onProfileUpdate={fetchVendorProfile}
      />
    </div>
  );
};

export default VendorProfile;